import {Constants} from '../providers/config';

export class GVLogger {

	constructor(){
	}

	public log(msg?:any){
		if(Constants.isDebugmode){
			console.log(msg);
		}
	}

}



// WEBPACK FOOTER //
// ./src/services/gv-logger.ts